import { VStack } from '@cbhq/cds-web/layout';
import { TextLabel2, TextTitle3 } from '@cbhq/cds-web/typography';

import { ReactComponent as LayerThreeSvg } from ':cloud/assets/Products/LayerThree.svg';

export function BaseAppchainPendingState() {
  return (
    <VStack
      width="100%"
      flexGrow={1}
      alignItems="center"
      gap={2}
      justifyContent="center"
      spacing={7}
      spacingTop={10}
    >
      <VStack maxWidth={300} alignItems="center" gap={2} spacingVertical={10}>
        <LayerThreeSvg width={96} height="auto" />
        <TextTitle3 as="h3">Deploying your L3...</TextTitle3>
        <TextLabel2 as="p" color="foregroundMuted" align="center">
          The deployment may take up to 15 minutes. Feel free to leave this page and come back.
        </TextLabel2>
      </VStack>
    </VStack>
  );
}
